export const titleText = "You are not Blessed";
export const contentText = "Wait your turn to enter the Temple\nand sacrifice a qualified NFT";
export const backButtonText = "Back";